import MomentUtils from '@date-io/moment';
import { Button, Checkbox, FormControlLabel, InputAdornment, TextField } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import _ from 'lodash';
import moment from 'moment';
import * as React from "react";
import Select, { SingleValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import CreditsIcon from '@material-ui/icons/MonetizationOn';
import { SubscriptionLogicEnum } from '../../repository/jago/model/input/ISubscriptionLogicEnum';
import { ISubscriptionResourceEnum } from '../../repository/jago/model/input/ISubscriptionResourceEnum';
import { ISubscriptionOutDTO } from '../../repository/jago/model/output/ISubscriptionOutDTO';
import { humanizeResource, normalizeResourceCode } from '../../repository/jago/model/input/subscriptionResourceUtils';
import Utils from '../../utils/Utils';
import ReduxLanguage from "../ReduxLanguage";
import translations from '../../translations/i18next';
import { SubscriptionProvisioningTypeEnum } from '../../repository/jago/model/input/ISubscriptionProvisioningTypeEnum';


const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    flex: 1,
  },
  formTitle: {
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  }
});


export interface INewPluginSubscriptionFormState {
  subscriptionData: ISubscriptionOutDTO;
  textInputErrors: { [key: string]: boolean; };
  isProvisioningSelectionDisabled: boolean;
};

export interface INewPluginSubscriptionFormProps extends WithStyles<typeof styles>{
  onCreatePluginSubscription: (subscription: ISubscriptionOutDTO) => void;
}

class NewPluginSubscriptionForm extends React.Component<INewPluginSubscriptionFormProps, INewPluginSubscriptionFormState> {

  constructor(props: INewPluginSubscriptionFormProps) {
    super(props);
    this.state = {
      subscriptionData: {
        name: '',
        sku: '',
        fixedPrice: 0,
        burnRate: 0,
        logic: SubscriptionLogicEnum.FIXED,
        maxLocks: 0,
        maxElements: 0,
        maxUsers: 0,
        nextTier: 0,
        prevTier: 0,
        resource: '',
        mainTier: 0,
        visible: true,
        provisioningType: SubscriptionProvisioningTypeEnum.MANUAL,
        requestToQuote: true,
        canBeDeactivated: true,
      },
      isProvisioningSelectionDisabled: true,
      textInputErrors: {
        name: false,
        fixedPrice: false,
        burnRate: false,
        sku: false,
        logic: false,
        maxLocks: false,
        maxElements: false,
        maxUsers: false,
        resource: false,
        mainTier: false,
      },
    };
  }
  
  public onSetValue(field: keyof ISubscriptionOutDTO, value: any) {
    const { subscriptionData } = this.state;
    if (value == null || value === '') {
      this.setErrorForField(field, true);
    } else {
      this.setErrorForField(field, false);
    }
    if (value && value < 0) {
      this.setErrorForField(field, true);
    }
    (subscriptionData as any)[field] = value;
    this.setState({ subscriptionData });
  }

  public onSelectResource(resource?: string | null) {
    const { subscriptionData } = this.state;
    subscriptionData.resource = resource ? resource : undefined;
    this.setState({ subscriptionData });
  }

  public onSelectLogic(logic?: SubscriptionLogicEnum | null) {
    const { subscriptionData } = this.state;
    if (logic) {
      subscriptionData.logic = logic;
    }
    this.setState({ subscriptionData });
  }

  public onSetOptionalText(field: 'category', value: string) {
    const { subscriptionData } = this.state;
    subscriptionData[field] = value;
    this.setState({ subscriptionData });
  }

  public onSelectProvisioning(provisioning: SingleValue<SubscriptionProvisioningTypeEnum>) {
    const { subscriptionData } = this.state;
    if (provisioning) {
      subscriptionData.provisioningType = provisioning;
    }
    this.setState({ subscriptionData });
  }

  public onSelectTier(tierId: number) {
    const { subscriptionData } = this.state;
    if (!tierId || tierId === 0) {
      this.setErrorForField('mainTier', true);
    }
    subscriptionData.mainTier = tierId;
    this.setState({ subscriptionData });
  }

  public setErrorForField(field: string, hasError: boolean) {
    const { textInputErrors } = this.state;
    textInputErrors[field] = hasError;
    this.setState({ textInputErrors });
  }

  public canSubmitForm() {
    const { subscriptionData } = this.state;
    if (!subscriptionData.name || !subscriptionData.sku || !subscriptionData.resource) {
      return false;
    }
    return true;
  }
    

  public onSubmitForm() {
    const { subscriptionData } = this.state;
    const { onCreatePluginSubscription } = this.props;
    if (this.canSubmitForm()) {
      const usesLocks = subscriptionData.logic === SubscriptionLogicEnum.COUNT_LOCKS || subscriptionData.logic === SubscriptionLogicEnum.COUNT_USERS_LOCKS;
      const usesUsers = subscriptionData.logic === SubscriptionLogicEnum.COUNT_USERS_LOCKS;
      const usesElements = subscriptionData.logic === SubscriptionLogicEnum.COUNT_ELEMENTS;
      onCreatePluginSubscription({
        ...subscriptionData,
        category: subscriptionData.category ? subscriptionData.category.trim() : undefined,
        maxLocks: usesLocks ? Number(subscriptionData.maxLocks) || 0 : 0,
        maxUsers: usesUsers ? Number(subscriptionData.maxUsers) || 0 : 0,
        maxElements: usesElements ? Number(subscriptionData.maxElements) || 0 : 0,
        fixedPrice: Utils.formatCreditsOut(subscriptionData.fixedPrice),
        burnRate: Utils.formatCreditsOut(subscriptionData.burnRate),
      });
    }
  }

  public onSetRequestToQuote(isChecked: boolean) {
    this.onSetValue('requestToQuote', isChecked);
    if (isChecked) {
      this.onSelectProvisioning(SubscriptionProvisioningTypeEnum.MANUAL);
    }
    this.setState({ isProvisioningSelectionDisabled: isChecked });
  }

/* Se logic è:
  - Fixed non mostrare maxLock, eleement e users
  - Count users -> mostra solo maxUsers
  - Count Locks -> mostra solo maxLocks
  - Count Elements -> mostra solo maxElements
- Fixed price è il costo di attivazione
- Burn rate è il costo ricorrente
*/

  public render() {
    const { classes } = this.props;
    const { subscriptionData, textInputErrors, isProvisioningSelectionDisabled } = this.state;
    const provisioningOptions = _.map(SubscriptionProvisioningTypeEnum, provisioningType => ({
      label: <ReduxLanguage languageKey={`forms.${provisioningType}`} />,
      value: provisioningType
    }));
    const resourceOptions = _.map(ISubscriptionResourceEnum, (v: string) => ({ value: v, label: `${humanizeResource(v)} (${v})` }));
    const selectedResourceOption = subscriptionData.resource
      ? _.find(resourceOptions, o => o.value === subscriptionData.resource) || { value: subscriptionData.resource, label: subscriptionData.resource }
      : null;
    const logicOptions = _.map(SubscriptionLogicEnum, logic => ({
      label: <ReduxLanguage languageKey={`forms.${logic}`} />,
      value: logic
    }));
    const selectedLogicOption = subscriptionData.logic ? _.find(logicOptions, o => o.value === subscriptionData.logic) : null;
    const selectedProvisioniOption = subscriptionData && subscriptionData.provisioningType ? _.find(provisioningOptions, provisioning => provisioning.value === subscriptionData.provisioningType) : null;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={moment.locale()}>
        <div className={classes.container}>
          <input autoComplete="new-password" style={{ display: 'none' }} />
          <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionName'} />}<span style={{ color: 'red' }}>*</span></h4>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            required
            style={{ marginTop: 10 }}
            error={textInputErrors.name}
            value={subscriptionData?.name}
            onChange={e => this.onSetValue('name', e.target.value)}
          />
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.sku'} />}<span style={{ color: 'red' }}>*</span></h4>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            required
            style={{ marginTop: 10 }}
            error={textInputErrors.sku}
            value={subscriptionData?.sku}
            onChange={e => this.onSetValue('sku', e.target.value)}
          />
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionResource'} />}<span style={{ color: 'red' }}>*</span></h4>
          <CreatableSelect
            options={resourceOptions}
            isClearable
            value={selectedResourceOption}
            placeholder={<ReduxLanguage languageKey={'forms.subscriptionResource'} />}
            formatCreateLabel={(input: string) => `${translations.t('forms.createResource')}: ${normalizeResourceCode(input)}`}
            isValidNewOption={(input: string) => normalizeResourceCode(input).length > 0}
            getNewOptionData={(input: string) => {
              const code = normalizeResourceCode(input);
              return { value: code, label: code };
            }}
            onChange={(e) => this.onSelectResource(e ? e.value : null)}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 20 }),
            }} 
          />
          <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionCategory'} />}</h4>
          <TextField
            variant="outlined"
            fullWidth
            style={{ marginTop: 10, marginBottom: 20 }}
            value={subscriptionData?.category || ''}
            onChange={e => this.onSetOptionalText('category', e.target.value)}
          />
          <FormControlLabel
            control={<Checkbox checked={subscriptionData?.visible} onChange={(e, checked) => this.onSetValue('visible', checked)} name="subscriptionVisible" />}
            label={<ReduxLanguage languageKey={'forms.subscriptionVisible'} />}
          />
          <>
            <FormControlLabel
              control={<Checkbox checked={subscriptionData?.canBeDeactivated} onChange={(e, checked) => this.onSetValue('canBeDeactivated', checked)} name="canBeDeactivated" />}
              label={<ReduxLanguage languageKey={'forms.subscriptionCanBeDeactivated'} />}
            />
            <h4 style={{ marginTop: -6, marginBottom: 10 }}><ReduxLanguage languageKey={`forms.subscriptionCanBeDeactivatedDescription`} /></h4>
          </>
          <FormControlLabel
            control={<Checkbox checked={subscriptionData?.requestToQuote} onChange={(e, checked) => this.onSetRequestToQuote(checked)} name="requestToQuote" />}
            label={<ReduxLanguage languageKey={'forms.requestToQuote'} />}
          />
          <h4 style={{ marginTop: -6, marginBottom: 10 }}><ReduxLanguage languageKey={`forms.requestToQuoteDescription`} /></h4>
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.provisioningType'} />}<span style={{ color: 'red' }}>*</span></h4>
          <Select
            options={provisioningOptions}
            isClearable
            isDisabled={isProvisioningSelectionDisabled}
            value={selectedProvisioniOption}
            placeholder={<ReduxLanguage languageKey={'forms.provisioningType'} />}
            onChange={(e) => this.onSelectProvisioning(e ? e.value : null)}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 20 }),
            }} 
          />
          {selectedProvisioniOption && selectedProvisioniOption.value ? (
            <h4 style={{ marginTop: -10, marginBottom: 10 }}><ReduxLanguage languageKey={`forms.${selectedProvisioniOption.value}_Description`} /></h4>
          ) : null}
          
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionFixedPrice'} />}<span style={{ color: 'red' }}>*</span></h4>
          <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionFixedPriceDescription'} />}</h5>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            required
            style={{ marginTop: 10 }}
            type={"number"}
            error={textInputErrors.fixedPrice}
            value={subscriptionData?.fixedPrice}
            onChange={e => this.onSetValue('fixedPrice', e.target.value)}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <CreditsIcon />
                </InputAdornment>
              }
            }
          />
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionBurnRate'} />}<span style={{ color: 'red' }}>*</span></h4>
          <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionBurnRateDescription'} />}</h5>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            required
            type={"number"}
            style={{ marginTop: 10 }}
            error={textInputErrors.burnRate}
            value={subscriptionData?.burnRate}
            onChange={e => this.onSetValue('burnRate', e.target.value)}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <CreditsIcon />
                </InputAdornment>
              }
            }
          />
          <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.subscriptionLogic'} />}<span style={{ color: 'red' }}>*</span></h4>
          <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionLogicDescription'} />}</h5>
          <Select
            options={logicOptions}
            placeholder={<ReduxLanguage languageKey={'forms.selectLogic'} />}
            onChange={(e) => this.onSelectLogic(e ? e.value : null)}
            value={selectedLogicOption}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10 }),
            }} 
          />
          {subscriptionData?.logic === SubscriptionLogicEnum.COUNT_LOCKS || subscriptionData?.logic === SubscriptionLogicEnum.COUNT_USERS_LOCKS ? (
            <div>
              <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.maxLocks'} />}<span style={{ color: 'red' }}>*</span></h4>
              <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionMaxLocksDescription'} />}</h5>
              <TextField
                variant="outlined"
                fullWidth
                required
                type={"number"}
                style={{ marginTop: 10 }}
                error={textInputErrors.maxLocks}
                value={subscriptionData?.maxLocks}
                onChange={e => this.onSetValue('maxLocks', e.target.value)}
              />
            </div>
          ) : null}
          {subscriptionData?.logic === SubscriptionLogicEnum.COUNT_USERS_LOCKS ? (
            <div>
              <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.maxUsers'} />}<span style={{ color: 'red' }}>*</span></h4>
              <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionMaxUsersDescription'} />}</h5>
              <TextField
                variant="outlined"
                fullWidth
                required
                type={"number"}
                style={{ marginTop: 10 }}
                error={textInputErrors.maxUsers}
                value={subscriptionData?.maxUsers}
                onChange={e => this.onSetValue('maxUsers', e.target.value)}
              />
            </div>
          ) : null}
          {subscriptionData?.logic === SubscriptionLogicEnum.COUNT_ELEMENTS ? (
            <div>
              <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'forms.maxElements'} />}<span style={{ color: 'red' }}>*</span></h4>
              <h5 style={{ margin: 0 }}>{<ReduxLanguage languageKey={'forms.subscriptionMaxElementsDescription'} />}</h5>
              <TextField
                variant="outlined"
                fullWidth
                required
                type={"number"}
                style={{ marginTop: 10 }}
                error={textInputErrors.maxElements}
                value={subscriptionData?.maxElements}
                onChange={e => this.onSetValue('maxElements', e.target.value)}
              />
            </div>
          ) : null}
          <Button
            variant="contained"
            disabled={!this.canSubmitForm()}
            style={{ width: '100%', opacity: this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', marginTop: 20, fontWeight: 'bold'  }}
            onClick={() => this.onSubmitForm()}
          >
            <ReduxLanguage languageKey="forms.save" />
          </Button>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withStyles(styles)(NewPluginSubscriptionForm);